import React, { useState, useEffect } from 'react';
import { MdAttachFile, MdEdit, MdDelete } from 'react-icons/md';
import AddResourceDocument from './AddResourceDocument';
import DeleteResourceDocument from './DeleteResourceDocument';
import { resourceDocumentApi } from '~/api';
import { DropDown } from '~/components';
import { Grid } from '~/components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { sortDates } from '~/util/sorters';

const headerClassName = 'bg-gray-50 p-2 border-b text-left';
const props = {
    className: 'p-2 pr-4 border-b text-sm'
};

const ResourceDocuments = () => {
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [rows, setRows] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [resourceDocument, setResourceDocument] = useState({});  
    const [editResourceDocument, setEditingResouceDoc] = useState(false);
    const [resourceDocumentId, setResourceDocumentId] = useState(0); 

    const columns = [
        { 
            title: 'Description', 
            field: 'Description',
            headerClassName,
            props
        },
        { 
            title: 'File', 
            field: 'File',
            headerClassName,
            props
        },
        {
            title: 'File Type',
            field: 'FileType',
            headerClassName,
            props
        },
        {
            title: 'Date Added',
            field: 'DateAdded',
            sorter: (a, b) => sortDates(a.DateAdded, b.DateAdded),
            headerClassName,
            props
        },
        {
            title: 'Action',
            cell: ({ data }) => {
                return (
                    <span className="flex justify-end">
                        <DropDown
                            wrapperClass="rounded-md border bg-white z-20 filter drop-shadow-xl right-1/4 top-full mt-1"
                            iconClass="text-white ml-2"
                            iconSize='1.25em'
                            buttonClass="py-1 pl-3 pr-2 bg-blue-50 text-white focus:outline-none rounded-full flex items-center justify-center"
                            text='Actions'>
                            <section className="flex flex-col items-stretch w-48 text-gray-80">
                                <p className="font-semibold text-sm p-4 py-2">Action</p>
                                <button className="btn btn-link py-2 px-4 hover:bg-blue-10 flex items-center" 
                                    onClick={() => onEditClick(data)}>
                                    <MdEdit />
                                    <span className="ml-2">Edit </span>
                                </button>
                                <button className="btn btn-link py-2 px-4 hover:bg-blue-10 flex items-center" 
                                    onClick={() => onDeleteClick(data)}>
                                    <MdDelete />
                                    <span className="ml-2">Delete </span>
                                </button>
                            </section>
                        </DropDown>
                    </span>
                );
            },
            headerClassName: headerClassName + ' pr-10 flex justify-end',
            props
        }
    ];

    const onEditClick = async (data) => {
        setFiltersOpen(true);
        setResourceDocument(data);
        setEditingResouceDoc(true);
    };

    const onDeleteClick = (data) => {
        setResourceDocumentId(data.id);
        setResourceDocument(data);
        setDeleteModalOpen(true);
    };

    const openModal = () => {
        setFiltersOpen(true);
        setEditingResouceDoc(false);
    };

    const closeModal = () => {
        setFiltersOpen(false);
    };

    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
    };

    useEffect(() => {
        let mounted = true;

        const fetchData = async() => {
            if(mounted) {
                let documentData = await resourceDocumentApi.getResourceDocuments();

                documentData = documentData.map((x) => {
                    let date_added = new Date(x.DateAdded);
                    return {
                        id: x.id,
                        Description: x.Description,
                        File: x.File,
                        FileType: x.FileType,
                        DateAdded: date_added.toDateString(),
                    };
                });
                
                setRows(documentData); 
                setLoading(false);
            }
            
        };

        fetchData();

        return () => mounted = false;
    }, []); 

    return(
        <>
            <div className="mt-6 mb-4 w-full flex flex-row justify-between">
                <div className="justify-start flex flex-col">
                    <h2 className="text-2xl text-blue-60 font-bold mb-2">Edit Resources</h2>
                    <p>Manage documents shown on the resources page.</p>
                </div>
                <div>
                    <button onClick={openModal} className=" py-2 px-4 bg-blue-50 text-white text-sm rounded-full flex items-center">
                        <MdAttachFile />
                        <span className="ml-1">Add Resources</span>
                    </button>
                </div>
            </div>
            {isLoading && (<AiOutlineLoading3Quarters/>)}
            {rows.length > 0 && 
                <Grid 
                    className='w-full text-sm'
                    rowSelect
                    data={rows}
                    columns={columns}
                    usePagination={true}
                /> 
            }
            <AddResourceDocument 
                filtersOpen={filtersOpen} 
                filtersClose={closeModal}
                resourceDocument={resourceDocument} 
                editResourceDocument={editResourceDocument}
            />
            <DeleteResourceDocument 
                filtersOpen={deleteModalOpen} 
                filtersClose={closeDeleteModal}
                resourceDocumentId={resourceDocumentId}
                resourceDocument={resourceDocument}  
            />
        </>
    );
};

export default ResourceDocuments;